export const NAME = "config";
